<template>
  <div class="app-container">
    <div
      ref="filterContainer"
      class="filter-container"
    >
      <!-- 后退、前进、设置列 -->
      <table-operation
        :init-table-column="masterList.initTableColumn"
        :table-columns.sync="masterList.tableColumns"
        :table-key="masterList.tableKey"
        :table-index.sync="masterList.tableIndex"
        :search-condition.sync="masterList.tableQuery"
        :table-transfer-name="getTransferName()"
        @reloadData="requestData()"
      />
    </div>
    <div class="container-box">
      <!-- 查询条件 -->
      <div ref="searchCondition">
        <el-row :gutter="10">
          <el-col style="width:40px;padding-left:10px;">
            <el-button
              type="text"
              style=""
            >
              查询：
            </el-button>
          </el-col>
          <el-col
            :xs="8"
            :sm="6"
            :md="4"
            :lg="3"
            :xl="2"
          >
            <el-input
              v-model="masterList.tableQuery.search.userName"
              placeholder="请输入店主名称"
              style="width:100%"
              clearable
              @keyup.enter.native="searchData()"
            />
          </el-col>
          <el-col
            :xs="8"
            :sm="6"
            :md="4"
            :lg="3"
            :xl="2"
          >
            <el-input
              v-model="masterList.tableQuery.search.phone"
              placeholder="请输入电话"
              style="width:100%"
              clearable
              @keyup.enter.native="searchData()"
            />
          </el-col>
          <el-col
            :xs="8"
            :sm="6"
            :md="4"
            :lg="3"
            :xl="2"
          >
            <el-select
              v-model="masterList.tableQuery.search.status"
              placeholder="请选择状态"
              clearable
              style="width:100%"
            >
              <el-option
                v-for="item in statusOptions"
                :key="item.data"
                :label="item.label"
                :value="item.data"
              />
            </el-select>
          </el-col>
          <el-col
            :xs="12"
            :sm="8"
            :md="6"
            :lg="4"
            :xl="3"
          >
            <el-button
              type="primary"
              @click="searchData()"
            >
              查询
            </el-button>
          </el-col>
        </el-row>
      </div>
      <!-- 数据列表 -->
      <custom-table
        :ref="masterList.tableKey"
        style="margin-top:5px"
        :data-obj="masterList"
        :table-key="masterList.tableKey"
        :table-columns="masterList.tableColumns"
        :table-data="masterList.tableData"
        :loading="masterList.tableLoading"
        :search-condition.sync="masterList.tableQuery"
        :data-total="masterList.tableDataTotal"
        :table-contextmenu="masterList.tableContextmenu"
        :table-custom-height="tableHeight"
        is-index-field
        is-paging
        @reloadData="loadTableData()"
        @add="addFun()"
        @edit="editFun(arguments)"
        @view="viewFun(arguments)"
        @del="delFun(arguments)"
        @dblclick="viewFun(arguments)"
        @export="batchExport(masterList)"
      />
    </div>
    <!-- 新增 修改 查看-->
    <add-edit-view-dialog
      :data-id="id"
      :event-type="eventType"
      :dialog-title="dialogAddEditViewTitle"
      :dialog-visible.sync="dialogAddEditViewVisible"
      :master-table-key="masterList.tableKey"
      @reloadData="loadTableData()"
    />
  </div>
</template>

<script>
// Table操作组件（后退、前进、列设置）
import TableOperation from '@/components/TableOperation'
// 列表设置tableKeyMixin
import tableOperationMixin from '@/mixin/tableOperationMixin'
// 导出 batchExportMixin
import batchExportMixin from '@/mixin/batchExportMixin'
// 自定义Table
import CustomTable from '@/components/CustomTable'
// 定义表头颜色，高度，查询，获取数据Mixin
import tableCustomMixin from '@/mixin/tableCustomMixin'
// 新增 修改
import AddEditViewDialog from './components/addEditViewDialog'
// 数据请求
import { loadAppUserScanAbnormalLockListDataApi, loadAppUserScanAbnormalLockExportDataApi, saveOrUpdateAppUserScanAbnormalLockApi } from '@/api/appUserScanAbnormalLock'

export default {
  name: 'AppUserScanAbnormalLock',
  components: {
    CustomTable,
    TableOperation,
    AddEditViewDialog
  },
  mixins: [tableCustomMixin, tableOperationMixin, batchExportMixin],
  data () {
    return {
      // 主列表
      masterList: {
        initTableColumn: [], // Table初始化列
        tableColumns: [], // Table列
        tableKey: 'app_user_scan_abnormal_lock_master', // Table Key
        tableIndex: 0, // Table Index
        tableLoading: true, // Table加载状态
        tableData: [], // Table数据
        tableDataTotal: 0, // Table总数据条数
        // Table右键
        tableContextmenu: [
          {
            permissionSigns: ['app_user_scan_abnormal_lock_add'],
            prop: 'add',
            label: '新增',
            method: 'add'
          },
          {
            permissionSigns: ['app_user_scan_abnormal_lock_edit'],
            prop: 'edit',
            label: '修改',
            method: 'edit'
          },
          {
            permissionSigns: ['app_user_scan_abnormal_lock_view'],
            prop: 'view',
            label: '查看',
            method: 'view'
          },
          {
            permissionSigns: ['app_user_scan_abnormal_lock_export'],
            prop: 'export',
            label: '导出',
            method: 'export'
          }
        ],
        tableQuery: {
          page: 1, // 页数
          limit: 50, // 每页条数
          contextmenuWrap: [], // 右键筛选字段
          // 排序对象
          sort: {
            prop: '', // 排序字段
            order: '' // 排序类型 asc升序 desc降序
          },
          // 查询条件
          search: {
            userName: '',
            phone: '',
            status: ''
          }
        }
      },
      id: null, // 选中的单据ID
      statusOptions: [{ data: 1, label: '锁定' }, { data: 2, label: '解除' }],
      eventType: '',
      dialogAddEditViewTitle: '',
      dialogAddEditViewVisible: false
    }
  },
  created () {
    // 初始化主列表Table列
    this.masterList.initTableColumn = [
      { prop: 'rowNumber', label: '序号', width: 80 },
      { prop: 'provinceName', filterColumn: 'r.province_name', label: '省区', width: 120 },
      { prop: 'cityName', filterColumn: 'r.city_name', label: '城市', width: 120 },
      { prop: 'userName', filterColumn: 'r.name', label: '名称', width: 120 },
      { prop: 'phone', filterColumn: 'r.phone', label: '电话', width: 120 },
      { prop: 'benxiangStoreNo', filterColumn: 'r.benxiang_store_no', label: '本香门店码', width: 160 },
      { prop: 'storeName', filterColumn: 'r.store_name', label: '店名', width: 120 },
      { prop: 'certificateNo', filterColumn: 'r.certificate_no', label: '专卖证号', width: 160 },
      { prop: 'lockTimeStr', filterColumn: 'i.lock_time', label: '设置时间', width: 160, isBetween: true },
      { prop: 'maxCount', filterColumn: 'i.max_count', label: '单日最大扫码数量', width: 160 },
      { prop: 'consumerDayCount', filterColumn: 'i.consumer_day_count', label: '消费者日扫码数量', width: 160 },
      { prop: 'consumerMonthCount', filterColumn: 'i.consumer_month_count', label: '消费者月扫码数量', width: 160 },
      { prop: 'statusStr', filterColumn: 'i.status', filterValue: 'status', label: '状态', width: 100, filterArray: [{ label: '有效', value: 1 }, { label: '无效', value: 2 }] },
      { prop: 'remark', filterColumn: 'i.remark', label: '备注' },
      { prop: 'operatorName', filterColumn: 'i.operator_name', label: '操作人', width: 150 },
      { prop: 'operationTimeStr', filterColumn: 'i.operation_time', label: '操作时间', width: 160, isBetween: true }
    ]
    // 默认主列表Table列
    this.getInitTableColumns()
    this.loadTableData()
  },
  methods: {
    // 请求数据
    requestData () {
      this.masterList.tableLoading = true
      let pageCondition = { condition: JSON.stringify(this.masterList.tableQuery) }
      loadAppUserScanAbnormalLockListDataApi(pageCondition).then(response => {
        this.masterList.tableLoading = false
        let data = response.data.data ? response.data.data : []
        this.handleData(data)
        this.masterList.tableDataTotal = response.data.recordsTotal
      }).catch()
    },

    // 新增
    addFun () {
      this.eventType = 'add'
      this.dialogAddEditViewVisible = !this.dialogAddEditViewVisible
      this.dialogAddEditViewTitle = '新增推荐码差异化设置信息'
    },
    // 修改
    editFun (args) {
      if (!args[0]) {
        this.$message({
          message: '请选择数据行',
          type: 'warning'
        })
        return
      }
      this.id = args[0].id
      this.eventType = 'edit'
      this.dialogAddEditViewVisible = !this.dialogAddEditViewVisible
      this.dialogAddEditViewTitle = '修改推荐码差异化设置信息'
    },
    // 查看
    viewFun (args) {
      if (!args[0]) {
        this.$message({
          message: '请选择数据行',
          type: 'warning'
        })
        return
      }
      this.id = args[0].id
      this.eventType = 'view'
      this.dialogAddEditViewVisible = !this.dialogAddEditViewVisible
      this.dialogAddEditViewTitle = '查看推荐码差异化设置信息'
    },
    // 作废
    delFun (args) {
      if (!args[0]) {
        this.$message({
          message: '请选择数据行',
          type: 'warning'
        })
        return
      } else if (args[0].status !== 1) {
        this.$message({
          message: '数据不在待确认状态，不能作废',
          type: 'warning'
        })
        return
      }
      this.$confirm('是否确定作废该推荐码差异化设置信息？', '系统提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          center: true
        }
      ).then(async () => {
        saveOrUpdateAppUserScanAbnormalLockApi({ id: args[0].id, isDel: "1" }).then(res => {
          if (res.mark === '200') {
            this.$message({
              message: res.message,
              type: 'success'
            })
            this.loadTableData()
          }
        })
      }).catch(() => { })
    },
    // 导出数据API
    ExportByPage () {
      let pageCondition = { condition: JSON.stringify(this.exportObj) }
      loadAppUserScanAbnormalLockExportDataApi(pageCondition).then(res => {
        let exportObj = { exportSuccess: true, url: res.data }
        this.$store.dispatch('message/settingExportSuccess', exportObj)
      })
    }
  }
}
</script>
